export const COOKIE_NAME = "pi_cookie_consent";
export const COOKIE_PREFERENCES_CHANGE_EVENT =
  "pi:cookie-preferences-changed";

export type CookiePreferences = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
};

export const buildPreferences = (
  analytics: boolean,
  marketing: boolean
): CookiePreferences => ({
  necessary: true,
  analytics,
  marketing,
});

export const serializePreferences = (preferences: CookiePreferences) =>
  JSON.stringify(preferences);

export const parsePreferences = (
  rawValue: string
): CookiePreferences | null => {
  try {
    const parsed = JSON.parse(rawValue) as Partial<CookiePreferences>;

    if (
      typeof parsed.analytics !== "boolean" ||
      typeof parsed.marketing !== "boolean"
    ) {
      return null;
    }

    return {
      necessary: true,
      analytics: parsed.analytics,
      marketing: parsed.marketing,
    };
  } catch {
    return null;
  }
};

export const DECLINE_VALUE = serializePreferences(
  buildPreferences(false, false)
);

const readCookieValue = (name: string) => {
  if (typeof document === "undefined" || !document.cookie) {
    return null;
  }

  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, ...valueParts] = cookie.split("=");

    if (decodeURIComponent(key) !== name) {
      continue;
    }

    return decodeURIComponent(valueParts.join("="));
  }

  return null;
};

export const getStoredCookiePreferences = () => {
  const rawValue = readCookieValue(COOKIE_NAME);

  if (!rawValue) {
    return null;
  }

  return parsePreferences(rawValue);
};

export const emitCookiePreferencesChange = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(COOKIE_PREFERENCES_CHANGE_EVENT));
};
